import Icon from '../components/Icon.vue'

Icon.register({
  'grin-wink': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M0 256c0-137 111-248 248-248s248 111 248 248-111 248-248 248-248-111-248-248zM200 208c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zM368 233c8.5 7.4 21.6 0.2 20-10.8-4-25.2-34.2-42.1-59.9-42.1-25.7 0-55.9 16.9-59.9 42.1-1.8 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM124.9 320.8c-11.4-3.7-22.7 6-20.7 17.9 9.3 55 83.2 93.3 143.8 93.3s134.6-38.3 143.8-93.3c1.9-11.9-9.4-21.6-20.7-17.9-30.2 9.7-75.1 15.2-123.1 15.2s-92.9-5.5-123.1-15.2z'
      }
    ]
  }
})
